import CampaignDashboard from "../../../pages/CampaignDashboard";

export default function MarketingPage() {
  return <CampaignDashboard />;
}
